/*eslint-disable no-restricted-globals */
import { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import APIEndpoints from '../../../../Member/api/APIEndpoints';
import { getFamilyList } from '../../../utils/Coverage';
import { axiosInstance } from '../../../../api/axios';

import { Search } from 'react-bootstrap-icons';
import moment from 'moment';
import { components } from '../../common/auto-suggestion-select/AsyncSelect';
import { setClaimNumbersList } from 'src/redux/member/uploadDocumentSlice';
import debounce from 'lodash.debounce';
import useDate from 'src/Member/utils/useDate';

const useUploadDocument = () => {
  const [files, setFiles] = useState([]);
  const [filesLoader, setfilesLoader] = useState(false);
  const [title, setTitle] = useState('');
  const [sendDocumentFor, setSendDocumentFor] = useState();
  const [referenceNumber, setReferenceNumber] = useState('');
  const [typeOptionList, setTypeOptionList] = useState([]);
  const [docType, setDocType] = useState();
  const [comments, setComments] = useState('');
  const [loadingApiConfig, setLoadingApiConfig] = useState(true);
  const [showUploadProgress, setShowUploadProgress] = useState(false);
  const [formOID, setSetFormOID] = useState('');
  const [formUploadStatus, setFormUploadStatus] = useState(false);
  const [fileUploadStatus, setFileUploadStatus] = useState('pending');
  const [fileProgress, setFileProgress] = useState(0);
  const [isOpenOverlayPopup, setIsOpenOverlayPopup] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [typeListValues, setTypeListValues] = useState([]);
  const [searchedClaimOptions, setSearchedClaimOptions] = useState([]);
  const [searchedDebounce, setsearchedDebounce] = useState('');

  //For DEMO purpose: Temp line of code for unhappy scenario
  //const [ tempCounter, setTempCounter ] = useState( 0 );

  const formRef = useRef(null);

  //overlay accessibility
  const overlayRef = useRef(null);
  const focusOnlyRef = useRef(null);
  const browseFileSeactionFocus = useRef(null);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { claimNumbersList } = useSelector((state) => state.uploadDocument);

  const onClickViewButton = () => {
    navigate('/member/view-all-documents', {
      state: {
        sendDocumentBackButton: true,
      },
    });
  };

  const { loggedInUserOID, loggedInMemberType, employeeInfo, dependentsInfo } =
    useSelector((state) => state.memberSummary);

  const { userData } = useSelector((state) => state.user);
  const { formatDate } = useDate();

  const sendDocumentForInfo = getFamilyList(
    employeeInfo,
    dependentsInfo,
    loggedInMemberType,
    loggedInUserOID,
  );

  const sendDocumentForOptionList = sendDocumentForInfo?.filter(
    (item) => !item?.value?.includes('Family'),
  );

  const CustomSearchIcon = (props) => (
    <components.DropdownIndicator {...props}>
      <Search color="black" />
    </components.DropdownIndicator>
  );

  const FormatOptionLabel = (props) => {
    //console.log('props:::', props);
    if (!props?.data?.data?.Claimnumber && !props?.data?.data?.ServiceDate) {
      return '';
    }
    const { Claimnumber, ServiceDate } = props.data.data;
    return (
      <components.Option {...props}>
        <div className="custom-select-options">
          <div className="select-options-content">
            <div className="d-flex">
              <div>{Claimnumber}</div>
            </div>
            <div>Service Date : {ServiceDate}</div>
          </div>
        </div>
      </components.Option>
    );
  };

  const coverageForInfo = getFamilyList(
    employeeInfo,
    dependentsInfo,
    loggedInMemberType,
    loggedInUserOID,
  );

  const fetchHippaCompliantClaims = (claimResultSet) => {
    const hippaComplianceOIDS = [];
    coverageForInfo.forEach((data) => {
      if (data.value != 'Family' && !hippaComplianceOIDS.includes(data.value)) {
        hippaComplianceOIDS.push(data.value);
      }
    });
    const hippaComplianceData = [];
    if (hippaComplianceOIDS?.length > 0 && claimResultSet?.length > 0) {
      claimResultSet.forEach((eachClaim) => {
        const memberORDependentOID = Object.prototype.hasOwnProperty.call(
          eachClaim,
          'DependentOid',
        )
          ? eachClaim.DependentOid
          : eachClaim.MemberOid;
        if (hippaComplianceOIDS.includes(memberORDependentOID)) {
          hippaComplianceData.push({
            ...eachClaim,
            PatientResponsibility:
              eachClaim.DisplayPaymentInfo !== 'true'
                ? -1
                : eachClaim.PatientResponsibility,
            //eachClaim.SuppressPaymentInfo === 'true'
            //? -1
            //: eachClaim.PatientResponsibility,
            ServiceDate: formatDate(eachClaim.ServiceDate),
          });
        }
      });
    }
    return hippaComplianceData;
  };

  const [claimNumberText, setClaimNumberText] = useState('');
  const [claimNumberLoading, setClaimNumberLoading] = useState(false);
  const {
    appConfigs: { Common_Setting },
  } = useSelector(({ app }) => app);
  const claimsYearRange =
    Common_Setting?.Claims_Year_Range != undefined
      ? Common_Setting?.Claims_Year_Range
      : 5;
  //Fetching Claims summary
  const fetchClaimsSummary = async () => {
    setClaimNumberLoading(true);
    const oid = employeeInfo.MemberOIDClaims;
    const memType = 'Family';
    try {
      const fromDate = new Date().getFullYear() - claimsYearRange + '-01-01';
      const toDate = moment(new Date()).format('YYYY-MM-DD');
      let claimResultSet = [];
      const claimsResponse = await axiosInstance.get(
        APIEndpoints.getClaimsListResource() +
          memType +
          '/oid/' +
          oid +
          '/AdminCenter/true' +
          '/pageSize/5000/incurreddatefrom/' +
          fromDate +
          '/incurreddateto/' +
          toDate,
      );
      claimResultSet = fetchHippaCompliantClaims(
        claimsResponse.data.Response.Claims,
      );
      claimResultSet.sort(
        (a, b) => new Date(b.ServiceDate) - new Date(a.ServiceDate),
      );

      const FILTERED_DATA = claimResultSet?.map((item) => {
        return {
          label: item?.Claimnumber,
          value: item?.Claimnumber,
          data: item,
        };
      });

      dispatch(setClaimNumbersList(FILTERED_DATA));
      return FILTERED_DATA;
    } catch (error) {
      console.log(error);
      return [];
    } finally {
      setClaimNumberLoading(false);
    }
    //if (inpuText?.length > 2) {
    //return claimNumbersList.filter((item) =>
    //item?.Claimnumber?.includes(inpuText),
    //);
    //}
  };

  const searchClaims = () => {
    const temp = claimNumbersList.filter((item) =>
      item.value.includes(claimNumberText),
    );
    setSearchedClaimOptions(temp?.slice(0, 25));
    console.log('temp', temp);
  };

  const debouncedCall = useCallback(
    debounce((currentVal) => setsearchedDebounce(currentVal), 800),
    [],
  );

  const onSearch = (event) => {
    if (event !== '') {
      setClaimNumberLoading(true);
    } else {
      setClaimNumberLoading(false);
    }
    setClaimNumberText(event);
    debouncedCall(event);
  };

  useEffect(() => {
    if (claimNumbersList?.length === 0) fetchClaimsSummary();
  }, []);

  useEffect(() => {
    if (claimNumberText.length >= 3) {
      searchClaims();
    }
    setClaimNumberLoading(false);
  }, [searchedDebounce]);

  //type field values calling

  const getTypeList = async () => {
    try {
      const responseDocument = await axiosInstance.get(
        APIEndpoints.getDocumentTypeList(),
      );
      const documentListData =
        responseDocument.data.Response.documentEntityDetailRespDTO;

      const responseList = documentListData.map((item) => {
        return { label: item.JmpEntityType, value: item.JmpEntityType };
      });

      const uniqueTypeData = [];
      for (let i = 0; i < responseList.length; i++) {
        if (
          !uniqueTypeData.find((item) => item.label === responseList[i].label)
        ) {
          uniqueTypeData.push(responseList[i]);
        }
      }
      setTypeListValues(documentListData);
      setTypeOptionList(uniqueTypeData);
      setLoadingApiConfig(false);
    } catch (err) {
      setLoadingApiConfig(false);
    }
  };

  useEffect(() => {
    getTypeList();
  }, []);

  //overlay accessibility
  const backToDocumentPageFocus = () => {
    setTimeout(() => {
      focusOnlyRef && focusOnlyRef.current.focus();
      setTimeout(() => {
        overlayRef && overlayRef.current.focus();
      }, 10);
    }, 500);
  };

  const schema = yup.object({
    senddocumentfor: yup
      .object()
      .required('Please select a send document for')
      .nullable(),
    title: yup.string().required('Enter Title '),
    referenceNumber: yup.string().when('type', {
      is: (val) => val?.label === 'Claims',
      then: () => yup.string().required('Please select a claim number'),
    }),
    type: yup.object().required('Please select a type').nullable(),
    comments: yup.string(),
    file: yup.object().required('please select file').nullable(),
  });
  const reviewForm = (errorLen) => {
    if (errorLen) {
      formRef.current.elements.item(0).focus();
    }
  };

  const getOIDs = (values) => {
    const sendForEmployee = Boolean(
      employeeInfo.OID === values.senddocumentfor.value,
    );
    const sendForDependent = Boolean(
      dependentsInfo.filter(
        (dependent) => dependent.OID === values.senddocumentfor.value,
      ).length,
    );

    return sendForEmployee
      ? { MemberOid: employeeInfo.OID, DependentOid: '' }
      : sendForDependent
      ? {
          MemberOid: employeeInfo?.OID || employeeInfo?.MemberOIDClaims,
          DependentOid: values.senddocumentfor.value,
        }
      : { MemberOid: '', DependentOid: '' };
  };

  const uploadFormData = async (values) => {
    const filteredVal = typeListValues.filter(
      (item) => item.JmpEntityType == values.type.value,
    );
    try {
      const memberDependentOID = getOIDs(values);
      const payLoad = {
        EntityType: filteredVal[0].CoreEntityType,
        EntityDesc: filteredVal[0].CoreEntityType,
        JMPEntityType: filteredVal[0].JmpEntityType,
        Title: title,
        ReferenceNumber: referenceNumber?.value,
        ImageType: filteredVal[0].ImageType,
        ImageDesc: filteredVal[0].ImageType,
        Totaldocument: Object.keys(values.file).length,
        UploadedByOid: userData.Oid,
        MemberType: values.senddocumentfor.memberType,
        Comment: comments,
        ...memberDependentOID,
      };

      //For DEMO purpose: Temp line of code for unhappy scenario
      //const tempPayLoad = {};

      //For DEMO purpose: replace tempPayLoad with payLoad
      const form = await axiosInstance.post(
        APIEndpoints.postFormDataUploadDocument(),
        payLoad,
      );
      //console.log( 'formBatchOid', form?.data?.Response?.oid );
      const formOID = form?.data?.Response;

      setSetFormOID(formOID);
      setFormUploadStatus(true);
      //Upload Files
      await initiateFileUpload(files, formOID);
      setfilesLoader(true);
    } catch (e) {
      setServerError(true);
    }
  };

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result
          .replace('data:', '')
          .replace(/^.+,/, '');
        return resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });

  const uploadFiles = async (fileItem, formOID, index) => {
    let percent = 0;
    const config = {
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        percent = Math.floor((loaded * 100) / total);
        if (percent <= 100) {
          setFileProgress(percent);
          setFiles((current) =>
            current.map((obj, i) => {
              if (i === index) {
                return { ...obj, uploadPercent: percent };
              }
              return obj;
            }),
          );
        }
      },
    };

    const payLoad = {
      DocControlNo: '',
      PDFLocation: '',
      OrigFileName: fileItem.file.name,
      chgUser: 'Test',
      chgts: '',
      LinkType: 'Image',
      Description: title,
      Notes: formOID.JVComment,
      ReceivedDate: '',
      ReceivedTime: '',
      EntityKey: formOID['ReferenceNumber/EntityKey'],
      EntityDesc: formOID.EntityDesc,
      EntityType: formOID.EntityType,
      ImageType: formOID.ImageType,
      UploadedBatchOid: formOID.UploadedBatchOid,
      StringContAFile: await fileToBase64(fileItem.file),
    };

    return axiosInstance
      .post(APIEndpoints.postFileDataUploadDocument(), payLoad, config)
      .then((res) => {
        setFiles((current) =>
          current.map((obj, i) => {
            if (i === index) {
              return { ...obj, uploadStatus: 'uploaded' };
            }
            return obj;
          }),
        );
        return res;
      })
      .catch((err) => {
        setFiles((current) =>
          current.map((obj, i) => {
            if (i === index) {
              return { ...obj, uploadStatus: 'failed' };
            }
            return obj;
          }),
        );
        return Promise.reject(err);
      });
  };

  const initiateFileUpload = (files, formOID) => {
    const uploadPromises = files.map((fileItem, index) => {
      //For DEMO purpose: Temp line of code for unhappy scenario
      //const tempOID = ( index === 0 || tempCounter === 2 ) ? formOID : 'formOID';

      if (fileItem.uploadStatus !== 'uploaded') {
        //For DEMO purpose: replace formOID with tempOID
        return uploadFiles(fileItem, formOID, index);
      }
    });

    Promise.all(uploadPromises)
      .then((values) => {
        setFileUploadStatus('uploaded');
      })
      .catch((values) => {
        setFileUploadStatus('failed');
      });
  };

  const submitData = async (values) => {
    //Show overlay
    //overlay accessibility
    setIsOpenOverlayPopup(true);

    //Upload Form Data and get OID
    uploadFormData(values);
  };

  const uploadDone = () => {
    history.go('/member/upload-document');
    //setShowUploadProgress( false );
    setIsOpenOverlayPopup(false);
    backToDocumentPageFocus();
  };

  const retryUploadAllFiles = async () => {
    //For DEMO purpose: Temp line of code for unhappy scenario
    //setTempCounter( counter => counter + 1 );
    setFileUploadStatus('pending');

    const retryFiles = files.map((file) =>
      file.uploadStatus === 'failed'
        ? { ...file, uploadStatus: 'pending', uploadPercent: 0 }
        : file,
    );
    setFiles(retryFiles);
    await initiateFileUpload(files, formOID);
    setfilesLoader(true);
  };

  return {
    files,
    filesLoader,
    title,
    sendDocumentFor,
    referenceNumber,
    docType,
    comments,
    schema,
    formRef,
    sendDocumentForOptionList,
    typeOptionList,
    loadingApiConfig,
    showUploadProgress,
    overlayRef,
    focusOnlyRef,
    isOpenOverlayPopup,
    formUploadStatus,
    fileUploadStatus,
    fileProgress,
    serverError,
    setShowUploadProgress,
    setFiles,
    setfilesLoader,
    setTitle,
    setSendDocumentFor,
    setReferenceNumber,
    setDocType,
    setComments,
    reviewForm,
    submitData,
    getTypeList,
    setTypeOptionList,
    setIsOpenOverlayPopup,
    backToDocumentPageFocus,
    uploadDone,
    retryUploadAllFiles,
    onClickViewButton,

    CustomSearchIcon,
    FormatOptionLabel,
    setClaimNumberText,
    claimNumberText,
    claimNumberLoading,
    claimNumbersList,
    searchedClaimOptions,
    defaultClaimList: claimNumbersList.slice(0, 5),
    onSearch,
    browseFileSeactionFocus,
  };
};

export default useUploadDocument;
